import React, { useContext } from "react";
import useForm from "../../../../services/UseForm";
import validate from '../../../../validations/admin/pos/cancleBillValidate';
import '../../../../css/Addingredient.css';
import axios from "axios";
import { API } from "../../../../services/api";
import { CancleContext } from "../cancelBill";

axios.defaults.baseURL = API;

function CancleBillDetails(props) {

    const {gTransactionID, userID, LocationID, setShowData, setShow} = useContext(CancleContext);

    const handleInputChange = event => {
        const { name, value } = event.target;
        handleChange(name, value);
    };

    async function HandleCancelBill () {
        let token = localStorage.getItem("token");
        var data = {
            Details: values.Details,
            TransactionID: gTransactionID,
            userID: userID,
        }
         await axios.post("/CancelBill",data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            getMemberIDFromTransaction(gTransactionID);  
            getTransactionDetail(gTransactionID);
            ClearData();
        }).catch((err) => {
            console.log(err);
        });
    }

    async function getMemberIDFromTransaction () {
        await axios.get(`/getMemberIDFromTransaction/${gTransactionID}`).then((response) => {
        let Data = response?.data;
        if(Data.length > 0){
            if(Data[0].MemberID){
            UpdateMember(Data[0].MemberID, Data[0].PreviousPoint, Data[0].PaidAmount);
            } 
        } 
        }).catch((error) => {
        console.log(error);
        });
    }

    async function UpdateMember(MemberID, PreviousPoint, PaidAmount) {
    let token = localStorage.getItem("token");
    var data = {
        MemberID: MemberID,
        Amount: PaidAmount,
        Point: PreviousPoint,
    }
    await axios.post("/usemember", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
    }).catch((err) => {
        console.log(err);
    });
    };


    async function getTransactionDetail () {
        await axios.get(`/getTransactionDetail/${gTransactionID}`).then((response) => {
        let Data = response?.data;
        if(Data.length > 0){
            for (var i=0; i < Data.length; i++) {
                getStoreInventory(Data[i].ProductID, Data[i].Quantity);
            } 
        } 
        }).catch((error) => {
        console.log(error);
        });
    }

    async function getStoreInventory (ProductID, Quantity) {
        let token = localStorage.getItem("token");
        var data = {
            ProductID: ProductID,
            LocationID: LocationID,
        }
        await axios.post("/getStoreInventory",data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            let inventoryData = response?.data;
            var gQuantity = 0;
            if(inventoryData.length > 0){
                gQuantity = Number(inventoryData[0].Quantity) + Number(Quantity);
                PlusInventory(inventoryData[0].StoreInventoryID, gQuantity);
            } 
        }).catch((err) => {
            console.log(err);
        });
    }

    async function PlusInventory (StoreInventoryID, Quantity) {
        let token = localStorage.getItem("token");
        var data = {
            StoreInventoryID: StoreInventoryID,
            Quantity: Quantity,
        }
        await axios.post("/PosUpdateStoreInventory", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
        }).catch((err) => {
            console.log(err);
        });
    }

    const ClearData = () => {
        setShowData([]);
        setShow(false);
        handleChange("Details", "")
    }

    const {
        values,
        errors,
        handleChange,
        handleSubmit,
    } = useForm(HandleCancelBill, validate);
 
    return (
        <div style={{ display: props && props.show ? 'flex' : 'none' }} className="AddIngredient">
            <div className="Ingredientcontent">
                <div className="IngredientHeader">
                    <span>ຍົກເລີກບິນ: {gTransactionID}</span>
                </div>
                <div className="IngredientBody">
                   <form onSubmit={handleSubmit} noValidate>
                        <div className="form-row">
                            <div className="col form-group">
                                <span>ເຫດຜົນ</span>
                                <input className={`input form-control ${errors.Details && 'is-invalid'}`} type="text" name="Details" onChange={(e) => handleInputChange(e)} value={values.Details || ''}  required />
                                {errors.Details && (
                                    <p className="invalid-feedback">{errors.Details}</p>
                                )}
                            </div> 
                        </div>
                        <div className="Ingredientfooter">
                            <button type="submit" className="btn btn-primary">
                                ຍົກເລີກບິນ
                            </button>
                            <button type="button" onClick={(e) => props.onClick(false)} className="btn btn-danger" data-dismiss="modal" aria-label="Close">
                                ກັບຄືນ
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default CancleBillDetails;
